{
  "add": "Add a thing",
  "add_photo": "Add photo",
  "capture_hint": "A link, a few words, or both. You can tidy it up later.",
  "capture_no_list": "Don't put it on {name}",
  "capture_on_list": "On {name}",
  "capture_placeholder": "Paste a link, a photo, or type a few words about what you want",
  "capture_title": "Add a thing",
  "count": {
    "one": "{count} thing",
    "other": "{count} things"
  },
  "details_hint": "Name, price and photo",
  "details_switch": "Get details from the page",
  "edit_failed": "That change didn't save. Try again?",
  "edit_thing": "Edit {name}",
  "edit_title": "Edit thing",
  "empty_body": "Tap + the moment you spot something you want. A link, a few words — whatever you've got.",
  "empty_heading": "Nothing here yet",
  "field_brand": "Brand",
  "field_lists": "Lists",
  "field_location": "Where you saw it",
  "field_note": "Note",
  "field_price": "Price",
  "field_store": "Store",
  "field_title": "Name",
  "field_url": "Link",
  "first_run_line": "Share from any app, paste a link, or take a photo: it all lands here.",
  "first_run_line_web": "Paste a link or take a photo: it all lands here.",
  "getting_details": "Getting details…",
  "gifted_badge": "Someone’s gifting you this",
  "gifted_note": "Someone’s gifting you this, so there’s no need to buy it yourself.",
  "got_cheer": "Cheers to that!",
  "got_section": "Got it",
  "heading": "My Things",
  "i_got_it": "I got it",
  "limit_list_full": "That list has {max} things, the most a list holds for now.",
  "limit_lists": "{max} lists is the most for now. Remove one to make another.",
  "limit_things": "You have {max} things, the most for now. Remove some you’ve got or don’t want anymore, then add more.",
  "limit_viewers": "{max} people is the most on one list for now.",
  "list_all": "All",
  "list_becoming_private": "Its things will stop being shared.",
  "list_becoming_private_kept": "Its things will stop being shared. The people on it stay, and see them again if you share it again.",
  "list_becoming_sharing": "Everything on this list will be visible to the people you share it with.",
  "list_becoming_sharing_parked": "Everything on this list will be visible to the people you share it with, and its things will show in All again.",
  "list_create": "Make list",
  "list_date": "When is it?",
  "list_date_clear": "Clear",
  "list_date_hint": "Something to look forward to. Leave it empty if there is no date.",
  "list_delete_failed": "Couldn’t remove that list. Try again?",
  "list_edit_title": "Edit list",
  "list_empty_body": "Add things to this list from a thing, or tap + while you are here.",
  "list_empty_heading": "Nothing on {name} yet",
  "list_file_failed": "That didn’t change the list. Try again?",
  "list_keep_out_hint": "Its things only show when you open this list. A place to park things.",
  "list_keep_out_switch": "Keep out of All",
  "list_link_after_save": "Once it’s saved, you can also make a link for family without the app.",
  "list_link_copied": "Copied",
  "list_link_copy": "Copy",
  "list_link_failed": "Couldn’t change the link. Try again?",
  "list_link_keep": "Keep it on",
  "list_link_label": "The list’s link",
  "list_link_off": "Off. Only the people above see this list.",
  "list_link_off_explain": "Turn the link off? It stops working for everyone who has it, and what they were gifting from it and hadn’t bought is let go.",
  "list_link_offline": "You’re offline. Try again once you’re connected.",
  "list_link_on": "They can look and gift — no account needed.",
  "list_link_preview": "See it as your family does",
  "list_link_send": "Send…",
  "list_link_share_text": "Here’s my {list} list on TingThings. Say what you’re gifting, so nobody doubles up — no app needed.",
  "list_link_switch": "Anyone with the link",
  "list_link_turn_off": "Turn off",
  "list_link_warning": "Anyone with it sees what’s taken — surprises too. To look yourself, use See it as your family does.",
  "list_name": "Name",
  "list_new": "New list",
  "list_new_title": "New list",
  "list_offer_body": "Anyone with the link can see this list and gift something from it — no app, no account.",
  "list_offer_done": "Done",
  "list_offer_here": "Here’s the link",
  "list_offer_make": "Make a link",
  "list_offer_not_now": "Not now",
  "list_offer_question": "Send a link to family without the app?",
  "list_offer_shared": "{list} is a sharing list",
  "list_offer_warning": "Anyone with it sees what’s taken — surprises too.",
  "list_remove": "Remove list",
  "list_remove_confirm": "Tap again. Its things stay.",
  "list_save_failed": "That list didn’t save. Try again?",
  "list_sharing": "Sharing list",
  "list_sharing_off": "Private. Only you see it.",
  "list_sharing_on": "Only the people you add see what is on it.",
  "list_sharing_switch": "Sharing list",
  "list_viewer_add_failed": "Couldn’t add them to that list. Try again?",
  "list_viewer_remove_failed": "Couldn’t take them off that list. Try again?",
  "list_viewers_add": "Add people",
  "list_viewers_add_name": "Add {name}",
  "list_viewers_add_one": "Add",
  "list_viewers_all_added": "Everyone who follows you is on this list.",
  "list_viewers_everyone": "Everyone on this list sees who else is on it.",
  "list_viewers_heading": "Who sees this",
  "list_viewers_kept": {
    "one": "{count} person is kept on this list, and sees it again if you share it again.",
    "other": "{count} people are kept on this list, and see it again if you share it again."
  },
  "list_viewers_no_followers": "Only people who follow you can be added. Invite someone, or tell them your handle, @{handle}, so they can follow you.",
  "list_viewers_none": "Nobody yet. Add people who follow you.",
  "list_viewers_on_create": "They go on the list when you make it.",
  "list_viewers_on_save": "Who sees this changes when you save.",
  "list_viewers_take_off": "Take off",
  "list_viewers_take_off_name": "Take {name} off this list",
  "lists_label": "Lists",
  "load_failed": "Could not load your things.",
  "location_denied": "TingThings isn't allowed to see your location, so this will save without it. You can allow it in Settings.",
  "location_finding": "Finding where you are…",
  "location_found": "Got it. Only you will see it.",
  "location_hint": "Keep where you saw it, so you can find it again. Only you see it.",
  "location_saved": "Location saved",
  "location_switch": "Remember where I am",
  "location_unavailable": "This device can't share its location, so this will save without it.",
  "more_details": "More details",
  "no_details": "No details from this page",
  "note_placeholder": "Size, colour, anything that helps",
  "open_in_maps": "Open in Maps",
  "open_link": "Open",
  "open_thing": "Open {name}",
  "outbox_dropped": "A thing you saved offline couldn't be added. Try capturing it again?",
  "page_description": "Everything you want, in one place.",
  "page_title": "My Things — TingThings",
  "parked_more": {
    "one": "{count} more on {name}",
    "other": "{count} more on {name}"
  },
  "parked_still_shared": "Still on {names}. The people you share it with can see it.",
  "parked_take_off": "Take it off",
  "photo_failed": "Saved, but the photo didn't upload. Add it again from the thing.",
  "photo_paste_hint": "Copied a photo? Paste it into the name or note.",
  "photo_preparing": "…",
  "photo_unreadable": "Couldn't read that photo.",
  "price_about": "about {price}",
  "price_invalid": "That doesn't look like a price.",
  "price_placeholder": "About how much?",
  "recently_added": "Recently added",
  "remove": "Remove",
  "remove_confirm": "Tap again to remove",
  "remove_failed": "Couldn't remove that. Try again?",
  "remove_location": "Remove",
  "remove_photo": "Remove photo",
  "replace_photo": "Replace photo",
  "retake_photo": "Retake",
  "save": "Save",
  "save_failed": "That didn't save. Try again?",
  "saving": "Saving…",
  "still_want_it": "Still want it",
  "store_placeholder": "Where it's sold",
  "take_photo": "Take a photo",
  "untitled": "Untitled",
  "url_invalid": "That doesn't look like a link.",
  "waiting_to_send": "Waiting to send"
}
